
import { Dispatch, SetStateAction } from 'react';
import { KaziModal } from '../../../Shared Components/Kazi/KaziModal';
import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface IncompleteProfileModalProps {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
}
export const IncompleteProfileModal = ({open, setOpen}:IncompleteProfileModalProps ) => {
    /* ******************** Hooks ******************** */
    const navigate = useNavigate();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handleClose = () => {
        setOpen(false);
        navigate('/')
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <KaziModal
            open={open}
            handleClose={handleClose}
            title='Incomplete Profile'
            content={
                <>
                    <Typography>Please complete your profile to access the marketplace</Typography>
                </>
            }
            actions={[<Button variant='outlined' onClick={handleClose}>Go back</Button>]}
        />
    )
}